// extracted by mini-css-extract-plugin
export default {"container":"CompletionTitle_container__eemqN","secondText":"CompletionTitle_secondText__iD66Y"};